import { Header } from "@/components/common";
import websitesImage from "@/assets/images/websites/website-builder.webp";

export default function WebsiteHero() {
    const scrollToPricing = () => {
        const pricingSection = document.getElementById('pricing-section');
        if (pricingSection) {
            pricingSection.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <section className="relative w-full overflow-hidden">
            <Header />
            <div className="container pt-12 pb-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <img
                            src={websitesImage}
                            alt="Website Builder"
                            className="w-full h-[250px] md:h-[400px] lg:h-[400px] object-cover rounded-3xl shadow-2xl shadow-purple-500/20"
                        />
                    </div>

                    <div className="space-y-6">
                        <div>
                            <span className="text-blue-500">
                                Website Builder
                            </span>
                            <h1 className="text-4xl md:text-5xl font-bold leading-tight mt-2">
                                <span className="text-white">Launch your website </span>
                                <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                                    with confidence
                                </span>
                            </h1>
                        </div>

                        <p className="text-gray-300 text-lg leading-relaxed">
                            Build a fast, mobile-ready website for your business and scale it with powerful built-in tools.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 pt-4">
                            <a 
                                href="https://sandomains.com/web-builder/"
                                className="px-8 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-lg hover:shadow-2xl hover:shadow-purple-500/50 transition-all hover:scale-105 text-center"
                            >
                                Start for Free
                            </a>
                            <button 
                                onClick={scrollToPricing}
                                className="px-8 py-3 bg-transparent text-white font-semibold rounded-lg border-2 border-gray-700 hover:border-purple-500 hover:bg-purple-500/10 transition-all text-center"
                            >
                                Hire an Expert
                            </button>
                        </div>

                        <p className="text-gray-300">
                            No credit card needed to get started.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}